<template>
    <div class="header">
        <Banner :list="bannerList" :height="80" :showBtn="false"></Banner>
    </div>
</template>

<style scoped>
.header{
    width: 1200px;
    overflow: hidden;
    margin: 0 auto;
}
.header-img{
    width: 1200px;
    overflow: hidden;
}
</style>

<script>
import Banner from "../components/Banner"
export default {
    name: 'Head',
    components:{Banner},
    data(){
        return {
            bannerList:[]
        }
    },
    mounted(){
        this.getBanners();
    },
    methods:{
        getBanners(){
            const self = this;
            this.$http.get("/bicycle/inter/banners?type=6").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.bannerList = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/Head.vue